import { StaticImage } from "gatsby-plugin-image";
import { ComponentPropsWithRef } from "react";
import { ScrollAnimation } from "~/components/shared/ScrollAnimation";
import { ColorCard } from "./ColorCard";
import { FeelCard } from "./FeelCard";
import * as styles from "./styles";

export const Concept = ({ ...props }: ComponentPropsWithRef<"div">) => {
  return (
    <section css={styles.concept} {...props}>
      <article>
        <ScrollAnimation>
          <h3 css={styles.conceptTitle}>ロゴマークの由来</h3>
          <p css={styles.conceptDescription}>
            わたしが知らなかった飾らないわたしにかえることができる場所、ふわっち。
            <br />
            ロゴでは、ふわっちで見つける「意外な自分の一面」を表現しています。
            <br />
            「ふわっち」のひらがな一文字一文字に「意外な自分の一面」を設定し、温かい筆のテクスチャは「伸び伸び自分らしさにかえる」ユーザーの姿を表現しています。
          </p>
        </ScrollAnimation>

        <ScrollAnimation>
          <div css={styles.yuraiLogo}>
            <StaticImage
              src="../../../images/img_logoyurai.png"
              alt="ふわっちロゴの由来"
              width={720}
              height={288}
            />
          </div>

          <ul css={styles.feelList}>
            <li>
              <FeelCard
                icon={
                  <StaticImage
                    src="../../../images/img_face1.png"
                    alt="お調子者のアイコン"
                    width={48}
                    height={48}
                  />
                }
                logo={
                  <StaticImage
                    src="../../../images/img_fu.png"
                    alt="ふわっちロゴのふ"
                    width={32}
                    height={32}
                  />
                }
                title="意外にお調子者の自分"
                description="あごを出しているような変顔もできる自分"
              />
            </li>
            <li>
              <FeelCard
                icon={
                  <StaticImage
                    src="../../../images/img_face2.png"
                    alt="大胆な自分のアイコン"
                    width={48}
                    height={48}
                  />
                }
                logo={
                  <StaticImage
                    src="../../../images/img_wa.png"
                    alt="ふわっちロゴのわ"
                    width={32}
                    height={32}
                  />
                }
                title="意外に大胆な自分"
                description="伸び伸び生きる自分を曲線で表現"
              />
            </li>
            <li>
              <FeelCard
                icon={
                  <StaticImage
                    src="../../../images/img_face3.png"
                    alt="慎重な自分のアイコン"
                    width={48}
                    height={48}
                  />
                }
                logo={
                  <StaticImage
                    src="../../../images/img_tsu.png"
                    alt="ふわっちロゴのっ"
                    width={32}
                    height={32}
                  />
                }
                title="意外に慎重な自分"
                description="周りの様子を伺いながら縮こまる自分"
              />
            </li>
            <li>
              <FeelCard
                icon={
                  <StaticImage
                    src="../../../images/img_face4.png"
                    alt="寂しがり屋の自分のアイコン"
                    width={48}
                    height={48}
                  />
                }
                logo={
                  <StaticImage
                    src="../../../images/img_chi.png"
                    alt="ふわっちロゴのち"
                    width={32}
                    height={32}
                  />
                }
                title="意外に寂しがり屋な自分"
                description="みんなに会いたい寂しい感情を持つ自分。一画目で困り眉を表現"
              />
            </li>
          </ul>
        </ScrollAnimation>
      </article>

      <article css={styles.colorsArticle}>
        <ScrollAnimation>
          <h3 css={styles.conceptTitle}>メインカラーとサブカラー</h3>
          <p css={styles.conceptDescription}>
            メインカラーのおかえりオレンジは、「おかえり」と思わず言いたくなるような、温かいおうちの電球色を表したオレンジです。
            <br />
            いつも誰かがいるふわっちに帰り、自分らしさに返ることができる温かいオレンジです。
          </p>

          <p css={styles.conceptDescription}>
            サブカラーの4色はふわっちの人間臭さを表す「血が通う暖色」です。楽しさから数度体温が上がるような様子を表現したカラーです。
          </p>
        </ScrollAnimation>

        <ScrollAnimation>
          <article css={styles.colorsContainer}>
            <h4 css={styles.colorTitle}>メインカラー</h4>
            <ColorCard
              css={styles.mainColor}
              title="おかえりオレンジ"
              hex="#fb5824"
              rgb="R251/G88/B36"
              iconSize="large"
              icon={
                <StaticImage
                  src="../../../images/img_okaeriorange.png"
                  alt="おかえりオレンジ"
                  width={200}
                  height={200}
                />
              }
            />

            <h4 css={styles.subColorTitle}>サブカラー</h4>

            <ul css={styles.subColors}>
              <li>
                <ColorCard
                  title="模様_pink"
                  hex="#ff275b"
                  rgb="R255/G39/B91"
                  icon={
                    <StaticImage
                      src="../../../images/img_pink.png"
                      alt="おかえりオレンジ"
                      width={160}
                      height={160}
                    />
                  }
                />
              </li>
              <li>
                <ColorCard
                  title="模様_yellow"
                  hex="#fca24a"
                  rgb="R252/G162/B74"
                  icon={
                    <StaticImage
                      src="../../../images/img_yellow.png"
                      alt="おかえりオレンジ"
                      width={160}
                      height={160}
                    />
                  }
                />
              </li>
              <li>
                <ColorCard
                  title="模様_orange"
                  hex="#ff772a"
                  rgb="R255/G119/B42"
                  icon={
                    <StaticImage
                      src="../../../images/img_orange.png"
                      alt="おかえりオレンジ"
                      width={160}
                      height={160}
                    />
                  }
                />
              </li>
              <li>
                <ColorCard
                  title="模様_red"
                  hex="#fe2525"
                  rgb="R254/G37/B37"
                  icon={
                    <StaticImage
                      src="../../../images/img_red.png"
                      alt="おかえりオレンジ"
                      width={160}
                      height={160}
                    />
                  }
                />
              </li>
            </ul>
          </article>
        </ScrollAnimation>
      </article>
    </section>
  );
};
